import React from 'react'
import PropTypes from 'prop-types'
import BEMHelper from '@ynap/bem-helper'

const bem = new BEMHelper('CheckoutPrice')

const propTypes = {
    className: PropTypes.string,
    wasOrderItemPrice: PropTypes.string,
    adjustedOrderItemPrice: PropTypes.string,
    promotions: PropTypes.arrayOf(
        PropTypes.shape({
            code: PropTypes.string.isRequired,
            amount: PropTypes.string.isRequired,
        })
    ).isRequired,
    finalPrice: PropTypes.string.isRequired,
    lineLevelTaxesEnabled: PropTypes.bool,
    markedDownPrice: PropTypes.string,
    DDPIncludedCountry: PropTypes.bool,
}
function Price(props) {
    const {
        className,
        originalPrice,
        markedDownPrice,
        adjustedOrderItemPrice,
        promotions = [],
        messages,
        markedDownPercentDiscount,
        salesTax,
        DDPCountry,
        DDPIncludedCountry,
        finalPrice,
        taxesAndDuties,
        lineLevelTaxesEnabled = false,
        designerName,
        badgeKey,
        locale,
    } = props

    // hack: do not use finalPrice if we are a DDP country - CHK-1327
    // this is because PDP displays prices ex tax for DDP countries at the moment
    const mainPrice = (!DDPCountry && finalPrice) || adjustedOrderItemPrice || markedDownPrice || originalPrice
    const firstMarkdown = markedDownPrice || originalPrice
    const secondMarkdown = originalPrice
    const showFirstMarkdown = mainPrice !== firstMarkdown
    const showSecondMarkdown = firstMarkdown !== secondMarkdown
    const hasPromotion = !!promotions.length
    const privateLabel = designerName === 'IRIS & INK' || badgeKey === 'BADGE_EXCLUSIVE'
    const discount = markedDownPercentDiscount > 0

    const renderDiscountLabels = () => {
        if (privateLabel && discount) {
            return (
                <>
                    <span className={bem('priceMessage')}>{messages?.price?.originalPrice?.()}</span>
                    <s className={bem('originalPrice')}>{originalPrice}</s>
                </>
            )
        } else if (!privateLabel && discount && locale === 'US') {
            return <span className={bem('thirdPartyUsModifier')}>{originalPrice}</span>
        } else if (!privateLabel && discount) {
            return (
                <>
                    <span className={bem('priceMessage')}>{messages?.price?.wasPrice?.()}</span>
                    <span className={bem('rrp')}>{originalPrice}</span>
                </>
            )
        } else {
            return (
                <>
                    {showSecondMarkdown ? <div className={bem('secondMarkdown')}>{secondMarkdown}</div> : null}
                    {markedDownPercentDiscount ? (
                        <div className={bem('percentageDiscount')}>{messages.price.discountPercentage({ discountPercentage: markedDownPercentDiscount })}</div>
                    ) : null}
                </>
            )
        }
    }

    return (
        <div className={bem(null, null, className)}>
            <div className={bem('markdowns', hasPromotion ? '' : 'markdownsModifier')}>
                {renderDiscountLabels()}
                {discount && <div className={bem('discount')}>{messages.price.discountPercentage({ discountPercentage: markedDownPercentDiscount })}</div>}
                {showFirstMarkdown ? (
                    <div className={bem(lineLevelTaxesEnabled && showSecondMarkdown ? 'wasPrice' : 'firstMarkdown', { showSecondMarkdown, hasPromotion })}>
                        {firstMarkdown}
                    </div>
                ) : null}
            </div>
            {lineLevelTaxesEnabled && salesTax && (
                <div className={bem('salesTax')}>
                    {messages.price.salesTax()}
                    {salesTax}
                </div>
            )}
            {lineLevelTaxesEnabled && taxesAndDuties && !DDPCountry && !DDPIncludedCountry && renderTaxes(DDPIncludedCountry, taxesAndDuties, messages)}
            <div className={bem('mainPrice')}>
                <div className={bem('priceToPay', privateLabel && !discount ? 'black' : '')}>{mainPrice}</div>
                {messages.price.taxIncluded ? <div className={bem('taxIncluded')}>{messages.price.taxIncluded()}</div> : null}
                {hasPromotion &&
                    promotions.map(({ description }, index) => (
                        <div className={bem('promotionApplied')} key={index}>
                            {messages.price.promoApplied({ description })}
                        </div>
                    ))}
            </div>
            {lineLevelTaxesEnabled && taxesAndDuties && (!!DDPCountry || !!DDPIncludedCountry) && renderTaxes(DDPIncludedCountry, taxesAndDuties, messages)}
        </div>
    )
}

function renderTaxes(DDPIncludedCountry, taxesAndDuties, messages) {
    return (
        <>
            {taxesAndDuties.hasTax && (
                <div className={bem('tax')}>
                    {messages.price.itemTax({ included: !!DDPIncludedCountry })}
                    <span className={bem('taxPrice')}>{taxesAndDuties.taxAmount}</span>
                </div>
            )}
            {taxesAndDuties.hasDuties && (
                <div className={bem('duties')}>
                    {messages.price.duties({ included: !!DDPIncludedCountry })}
                    <span className={bem('taxPrice')}>{taxesAndDuties.dutiesAmount}</span>
                </div>
            )}
        </>
    )
}

Price.propTypes = propTypes

export default Price
